import * as React from 'react';
import {
  PageSection,
  Title,
  Form,
  FormGroup,
  TextInput,
  DatePicker,
  Grid,
  FormSection,
  Button,
} from '@patternfly/react-core';
import { TProject } from '@app/config/types';
import { StoreContext } from '@app/store';
import { ADD_PROJECT, ARRAY_CHILD_CHANGE, REMOVE_ITEM_FROM_ARRAY } from '@app/config/constants';

const ProjectsForm: React.FunctionComponent = () => {
  const { state, dispatch } = React.useContext(StoreContext);
  return (
    <PageSection>
      <Title headingLevel="h1" size="lg">
        My Information
      </Title>
      <Form onSubmit={(e) => e.preventDefault()}>
        {state.projects.map((item: TProject, index) => (
          <FormSection key={index}>
            <Grid hasGutter md={6}>
              <FormGroup label="Role" isRequired fieldId="simple-form-name-01">
                <TextInput
                  isRequired
                  type="text"
                  id="simple-form-name-01"
                  name="simple-form-name-01"
                  aria-describedby="simple-form-name-01-helper"
                  value={item.role}
                  onChange={(value) =>
                    dispatch({
                      type: ARRAY_CHILD_CHANGE,
                      payload: {
                        key: 'projects',
                        index,
                        childKey: 'role',
                        value,
                      },
                    })
                  }
                />
              </FormGroup>
              <FormGroup label="Project Name" isRequired fieldId="simple-form-name-02">
                <TextInput
                  isRequired
                  type="text"
                  id="simple-form-name-02"
                  name="simple-form-name-02"
                  aria-describedby="simple-form-name-02-helper"
                  value={item.name}
                  onChange={(value) =>
                    dispatch({
                      type: ARRAY_CHILD_CHANGE,
                      payload: {
                        key: 'projects',
                        index,
                        childKey: 'name',
                        value,
                      },
                    })
                  }
                />
              </FormGroup>
              <FormGroup label="Project Link" isRequired fieldId="simple-form-name-02">
                <TextInput
                  isRequired
                  type="text"
                  id="simple-form-name-02"
                  name="simple-form-name-02"
                  aria-describedby="simple-form-name-02-helper"
                  value={item.link}
                  onChange={(value) =>
                    dispatch({
                      type: ARRAY_CHILD_CHANGE,
                      payload: {
                        key: 'projects',
                        index,
                        childKey: 'link',
                        value,
                      },
                    })
                  }
                />
              </FormGroup>
              <FormGroup label="Project Description" isRequired fieldId="simple-form-name-02">
                <TextInput
                  isRequired
                  type="text"
                  id="simple-form-name-02"
                  name="simple-form-name-02"
                  aria-describedby="simple-form-name-02-helper"
                  value={item.description}
                  onChange={(value) =>
                    dispatch({
                      type: ARRAY_CHILD_CHANGE,
                      payload: {
                        key: 'projects',
                        index,
                        childKey: 'description',
                        value,
                      },
                    })
                  }
                />
              </FormGroup>
              <FormGroup label="Start Date" isRequired fieldId="simple-form-link-01">
                <DatePicker
                  value={item.start_date}
                  onChange={(value) =>
                    dispatch({
                      type: ARRAY_CHILD_CHANGE,
                      payload: {
                        key: 'projects',
                        index,
                        childKey: 'start_date',
                        value,
                      },
                    })
                  }
                />
              </FormGroup>
              <FormGroup label="End Date" isRequired fieldId="simple-form-link-01">
                <DatePicker
                  value={item.end_date}
                  onChange={(value) =>
                    dispatch({
                      type: ARRAY_CHILD_CHANGE,
                      payload: {
                        key: 'projects',
                        index,
                        childKey: 'end_date',
                        value,
                      },
                    })
                  }
                />
              </FormGroup>
              <Button
                variant="danger"
                onClick={() =>
                  dispatch({
                    type: REMOVE_ITEM_FROM_ARRAY,
                    payload: {
                      key: 'projects',
                      index,
                    },
                  })
                }
              >
                Remove
              </Button>
            </Grid>
          </FormSection>
        ))}
        <Button
          variant="primary"
          onClick={() =>
            dispatch({
              type: ADD_PROJECT,
            })
          }
        >
          Add Project
        </Button>
      </Form>
    </PageSection>
  );
};

export { ProjectsForm };
